import { withI18n } from 'react-i18next';
import { connect } from 'react-redux';

import { signInActions } from 'src/store/modules/signin';

import RegionSwitch from './RegionSwitch';

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  signout: () => dispatch(signInActions.signout())
});

export const pureComponent = RegionSwitch;
export default connect(null, mapDispatchToProps)(withI18n()(RegionSwitch));

interface IDispatchFromProps {
  signout(): void;
}
